

































import { Component, Prop, Mixins } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import { DataModules } from "@/store/modules/data";
import HasValidation from "@/mixins/HasValidation";
import { ValidationObserver } from "vee-validate";
import { IInvoice } from "@/models/invoices";

@Component
export default class CancelInvoiceModal extends Mixins(
  RequestPromises,
  HasValidation
) {
  public $refs!: {
    cancellationReasonInput: HTMLFormElement;
    observer: InstanceType<typeof ValidationObserver>;
  };

  @Prop({ required: true })
  public invoiceId!: IInvoice["id"];

  public isProcessing = false;
  public cancellationReason = "";

  public mounted() {
    this.$nextTick(() => {
      this.$refs.cancellationReasonInput.$el.querySelector("textarea").select();
    });
  }

  public cancel() {
    return this.$store.dispatch(`data/${DataModules.INVOICES}/cancel`, {
      vm: this,
      ignoreStored: true,
      invoiceId: this.invoiceId,
      data: { cancellation_reason: this.cancellationReason }
    });
  }

  public async validateBeforeSubmit() {
    this.isProcessing = true;
    try {
      if (!(await this.validate())) {
        throw this.$t("_sentence.form_is_not_valid");
      }
      await this.cancel();
      this.$buefy.toast.open({
        message: this.$t("_.invoice_cancelled_successfully") as string
      });
      this.$emit("invoice-cancelled");
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    }
    this.isProcessing = false;
  }
}
